// features/licenses/context.tsx
import React, { createContext, useCallback, useMemo, useReducer, PropsWithChildren } from "react";
import { initialState } from "./state";
import { licensesReducer, type Action } from "./reducer";
import type { LicensesState } from "./types";
import { createActions, type LicensesActions } from "./actions";

export const StateCtx = createContext<LicensesState | undefined>(undefined);
export const ActionsCtx = createContext<LicensesActions | undefined>(undefined);

export const LicensesProvider = ({ children }: PropsWithChildren) => {
  const [state, dispatch] = useReducer(licensesReducer, initialState);
  const getState = useCallback(() => state, [state]);
  const actions = useMemo(() => createActions(dispatch, getState), [dispatch, getState]);

  return (
    <StateCtx.Provider value={state}>
      <ActionsCtx.Provider value={actions}>{children}</ActionsCtx.Provider>
    </StateCtx.Provider>
  );
};
